// import React from 'react';
// import { useTranslation } from 'react-i18next';
// import { changeLanguage } from '../i18n/config';

// const LanguageSwitcher = () => {
//   const { i18n } = useTranslation();
  
//   const toggleLanguage = () => {
//     const newLang = i18n.language === 'ar' ? 'en' : 'ar';
//     changeLanguage(newLang);
//     // Reload page to refresh all components with new language
//     window.location.reload();
//   };
  
//   return (
//     <button 
//       onClick={toggleLanguage}
//       className="px-3 py-1 rounded bg-green-600 text-white hover:bg-green-700 transition"
//     >
//       {i18n.language === 'ar' ? 'English' : 'العربية'}
//     </button>
//   );
// };

// export default LanguageSwitcher;
import React from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../i18n/config';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  
  const toggleLanguage = () => {
    const newLang = i18n.language === 'ar' ? 'en' : 'ar';
    changeLanguage(newLang);
  };
  
  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-4 py-2 bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 border border-gray-200"
    >
      {i18n.language === 'ar' ? (
        <span className="text-sm font-medium text-gray-700">English</span>
      ) : (
        <span className="text-sm font-medium text-gray-700">العربية</span>
      )}
    </button>
  );
};

export default LanguageSwitcher;